// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3I5cr","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2W8wv"};